// Prévia ao vivo: iframe isolado (sandbox sem same-origin) com o MESMO renderizador da página publicada.
// O documento vem do servidor (rota /preview, com CSP própria) uma vez; depois cada mudança é enviada por postMessage
// (sem recarregar nem perder a rolagem). O rascunho em edição chega no lp:ready.
import { useEffect, useRef } from 'react'
import { landingBody, landingCss, landingFontHref, type LandingContent } from '@impulso/shared/landing'

export interface PreviewProps {
  src: string
  content: LandingContent
  assetUrl: (id: string) => string | null
  selectedId: string | null
  device: 'desktop' | 'mobile'
  onSelect: (id: string) => void
  pageTitle: string
}

export default function Preview({ src, content, assetUrl, selectedId, device, onSelect, pageTitle }: PreviewProps) {
  const ref = useRef<HTMLIFrameElement>(null)
  const ready = useRef(false)
  const latest = useRef({ content, assetUrl, selectedId, pageTitle })
  latest.current = { content, assetUrl, selectedId, pageTitle }

  const post = (msg: unknown) => ref.current?.contentWindow?.postMessage(msg, '*')
  const render = () => {
    const { content: c, assetUrl: a, selectedId: s, pageTitle: t } = latest.current
    post({ type: 'lp:render', css: landingCss(c.theme), body: landingBody(c, { assetUrl: a, editor: true, pageTitle: t }), fontHref: landingFontHref(c.theme), selected: s })
  }

  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      if (e.source !== ref.current?.contentWindow) return
      const d = e.data as { type?: string; id?: string }
      if (d?.type === 'lp:ready') { ready.current = true; render() }
      if (d?.type === 'lp:select' && typeof d.id === 'string') onSelect(d.id)
    }
    window.addEventListener('message', onMsg)
    return () => window.removeEventListener('message', onMsg)
  }, [onSelect])

  useEffect(() => {
    if (ready.current) render()
  }, [content, assetUrl])

  useEffect(() => {
    if (ready.current) post({ type: 'lp:select', id: selectedId })
  }, [selectedId])

  return (
    <div className={`lpe-frame ${device}`}>
      <iframe ref={ref} title="Prévia da página" src={src} sandbox="allow-scripts" />
    </div>
  )
}
